<template>
  <div class="rank">
    <div class="section" v-for="(rank, i) in rankLists" :key="i">
      <div class="title">
        {{ rank }}
      </div>
      <div class="list">
        <div
          class="list-item pointer flex flex-top"
          v-for="(item, j) in list[i]"
          :key="j"
          @click="fileDetailsClick(item.standardFileId)"
        >
          <div class="list-item-index">{{ j + 1 }}</div>
          <div class="flex-1 ellipsis" :title="item.standardFileTitle">
            {{ `【${item.standardFileCode}】${item.standardFileTitle}` }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { standardFileList } from "@/api/standardFile";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      page: { pageIndex: 1, pageSize: 10 },
      rankLists: ["热门下载", "最新上传", "推荐文档"],
      list: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters(["token"]),
  },
  methods: {
    async getList() {
      const hotDownload = await this.$axios.post(standardFileList, {
        ...this.page,
        standardFileHotDownloadStatus: "1",
      });
      this.list.push(hotDownload.list || []);

      const news = await this.$axios.post(standardFileList, {
        ...this.page,
        standardFileNewStatus: "1",
      });
      this.list.push(news.list || []);
      const recomment = await this.$axios.post(standardFileList, {
        ...this.page,
        standardFileRecommendStatus: "1",
      });
      this.list.push(recomment.list || []);
    },
    async fileDetailsClick(id) {
      if (this.token) {
        const { href } = this.$router.resolve({
          path: "/standardFileDetail",
          query: {
            id,
          },
        });
        window.open(href);
      } else {
        this.$store.dispatch("login");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variable";
.rank {
  .section {
    background-color: #fff;
    margin-bottom: 20px;
    min-height: 310px;
    .title {
      font-size: 16px;
      text-align: center;
      padding: 10px 0;
      color: white;
      background: url($oss-url + "home/title-bg/title-bg-1.png") center
        center/cover no-repeat;
    }
    &:nth-child(1) {
      .title {
        background: url($oss-url + "home/title-bg/title-bg-1.png") center
          center/cover no-repeat;
      }
    }
    &:nth-child(2) {
      .title {
        background: url($oss-url + "home/title-bg/title-bg-5.png") center
          center/cover no-repeat;
      }
    }
    &:nth-child(3) {
      .title {
        background: url($oss-url + "home/title-bg/title-bg-4.png") center
          center/cover no-repeat;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
    .list {
      &-item {
        border-top: 1px solid #e6e6e6;
        padding: 10px;
        &:hover {
          color: $theme-color;
        }
        &-index {
          width: 24px;
          height: 24px;
          line-height: 24px;
          border-radius: 12px;
          margin-right: 10px;
          background: $theme-color;
          color: #fff;
          text-align: center;
        }
      }
    }
    &:nth-child(2) {
      .list {
        &-item-index {
          background: #ff9531;
        }
      }
    }
    &:nth-child(3) {
      .list {
        &-item-index {
          background: #39d037;
        }
      }
    }
  }
}
</style>
